/* bk-featured-products: chip tabs toggle pre-rendered grids without a page reload. */
(function () {
  function init(root) {
    const tabs = Array.from(root.querySelectorAll('[data-bk-featured-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-bk-featured-panel]'));
    const viewAll = root.querySelector('[data-bk-featured-all]');
    if (!tabs.length) return;

    function select(tab) {
      const id = tab.getAttribute('data-bk-featured-tab');
      tabs.forEach(function (t) {
        t.setAttribute('aria-pressed', String(t === tab));
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-bk-featured-panel') !== id;
      });
      const url = tab.getAttribute('data-url');
      if (viewAll && url) viewAll.setAttribute('href', url);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        select(tab);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-bk-featured]').forEach(function (root) {
      if (root.dataset.bkFeaturedReady) return;
      root.dataset.bkFeaturedReady = 'true';
      init(root);
    });
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
